import type { ID, Snapshot } from '@proofroom/schema';
import type { SnapshotIndex } from '../model/snapshotIndex';

export interface NavigatorProps {
  idx: SnapshotIndex;
  current: number;
  oversetSpreads: Set<number>;
  onSelect(i: number): void;
}

function thumbUrl(snapshot: Snapshot, idx: SnapshotIndex, si: number): string | undefined {
  const r = snapshot.spreads[si].rasters;
  const ref = r?.full ?? r?.art;
  return ref ? idx.assets[ref.assetId]?.url : undefined;
}

/** Spread thumbnails from the exported rasters, with an overset dot on affected spreads. */
export function Navigator({ idx, current, oversetSpreads, onSelect }: NavigatorProps) {
  const { snapshot } = idx;
  return (
    <nav className="navigator" aria-label="Pages" data-tour="pages">
      {snapshot.spreads.map((s, i) => {
        const url = thumbUrl(snapshot, idx, i);
        const ar = s.pages.length ? s.pages[0].bounds.w / s.pages[0].bounds.h : 0.707;
        return (
          <button key={s.id as ID} className={`thumb${i === current ? ' current' : ''}`} onClick={() => onSelect(i)} aria-current={i === current ? 'page' : undefined}>
            <div className="pages" style={{ ['--ar' as string]: ar }}>
              {url ? (
                <div className="pg" style={{ aspectRatio: `${s.bounds.w} / ${s.bounds.h}` }}><img src={url} alt="" loading="lazy" />{oversetSpreads.has(i) && <span className="ov" title="Overset text" />}</div>
              ) : (
                s.pages.map((p) => <div key={p.id} className="pg">{oversetSpreads.has(i) && <span className="ov" title="Overset text" />}</div>)
              )}
            </div>
            <div className="cap"><span className="num">{s.pages.map((p) => p.number).join(' - ')}</span><span>{i + 1}/{snapshot.spreads.length}</span></div>
          </button>
        );
      })}
    </nav>
  );
}
